import React from "react";

export default function Features() {
  const list = [
    "Créez des objectifs fitness personnalisés",
    "Planification hebdomadaire intelligente",
    "Séances générées automatiquement",
    "Analyse du temps, calories et performance",
    "Connexion avec un coach pour un suivi 1:1"
  ];

  return (
    <section id="features">
      <div className="container">
        <h2>Des fonctionnalités puissantes pour vous faire progresser</h2>
        <ul>
          {list.map((item, i) => (
            <li key={i} style={{ margin: "15px 0", opacity: 0.8 }}>
              🟦 {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
